import { render, staticRenderFns } from "./fulfillment-detail-request.vue?vue&type=template&id=e5132e08&scoped=true"
import script from "./fulfillment-detail-request.vue?vue&type=script&lang=js"
export * from "./fulfillment-detail-request.vue?vue&type=script&lang=js"
import style0 from "./fulfillment-detail-request.vue?vue&type=style&index=0&id=e5132e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5132e08",
  null
  
)

export default component.exports